import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { cx } from "../../lib/cx";
import { Icon, type IconName } from "../core/Icon";
import s from "./EmptyState.module.css";

export interface EmptyStateProps extends Omit<ComponentPropsWithoutRef<"div">, "title"> {
  icon?: IconName;
  title: string;
  /** El hecho y el paso siguiente: "Todavía no hay escaneos. Los datos aparecen a las 24 h." */
  children?: ReactNode;
  /** Un `Button`, normalmente. */
  action?: ReactNode;
  /** `dashed` para un hueco donde va a haber algo; `filled` para una lista sin resultados; `plain` sin marco ni
   *  fondo, con el icono en violeta, para vivir adentro de una superficie que ya lo tiene (una tabla vacía). */
  tone?: "filled" | "dashed" | "plain";
}

/** Lista sin resultados o sección todavía vacía. Dice el hecho y después la acción. */
export function EmptyState({ icon, title, children, action, tone = "filled", className, ...rest }: EmptyStateProps) {
  return (
    <div className={cx(s.vacio, className)} data-tone={tone} {...rest}>
      {icon ? (
        <span className={s.icono}>
          <Icon name={icon} size={24} />
        </span>
      ) : null}
      <h3 className={s.titulo}>{title}</h3>
      {children ? <div className={s.texto}>{children}</div> : null}
      {action ? <div className={s.accion}>{action}</div> : null}
    </div>
  );
}
